import React from 'react';
import { TwitterPicker } from 'react-color';

import './App.css';

import { colourPickerContainerStyle, colourPickerHeadingStyle, colourPickerCardStyle } from './styles/colour-picker-styles';

const colors = ['#0066CC', '#1A1A1A', '#666666'];

class IconsColourPicker extends React.Component {
	state = {
		color: colors[0],
	};

	handleChangeComplete = color => {
		document.body.style.color = color.hex;
		this.setState({ color: color.hex });
	};

	render() {
		return (
			<div style={colourPickerContainerStyle}>
				<p id="colour-selector" style={colourPickerHeadingStyle}>
					{document.documentElement.lang === 'en' ? 'Colour options' : 'Options de couleur'}
				</p>
				<TwitterPicker
					aria-describedby="colour-selector"
					triangle="hide"
					colors={colors}
					color={this.state.color}
					onChangeComplete={this.handleChangeComplete}
					styles={colourPickerCardStyle}
				/>
			</div>
		);
	}
}

export default IconsColourPicker;
